// src/layouts/WebsiteLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import HomeNavbar from "./components/homeNavbar";
import Footer from "./components/footer";

export default function WebsiteLayout() {
    return (
        <div className="min-h-screen flex flex-col">
            <HomeNavbar />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
